import React from 'react';
import { motion } from 'framer-motion';
import logo from '/assets/icons/logo.svg'

const Logo = () => {
  return (
    <motion.div 
      className="flex items-center justify-center"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <img src={logo} alt="Logo" className="" style={{ width: '100px', height: '100px' }} />
    </motion.div>
  );
};

export default Logo;